const sortObjects = (objects, key, order = 'ASC') => {
  const getNestedValue = (object, key) => {
    if (typeof key === 'string') {
      return getNestedValue(object, key.split('.'));
    }
    const [nextPart, ...restOfParts] = key;
    if (restOfParts.length === 0) {
      return object[nextPart];
    }
    return getNestedValue(object[nextPart], restOfParts);
  };

  const sorted = objects.sort((object1, object2) => {
    const value1 = getNestedValue(object1, key);
    const value2 = getNestedValue(object2, key);

    if (typeof value1 === 'boolean') {
      if (value1 && value2) {
        return 0;
      }
      if (value1 && !value2) {
        return -1;
      }
      if (!value1 && value2) {
        return 1;
      }
      return 0;
    }

    if (typeof value1 === 'string') {
      const lowerValue1 = (value1 || '').toLowerCase();
      const lowerValue2 = (value2 || '').toLowerCase();
      return lowerValue1 < lowerValue2 ? -1 : lowerValue1 > lowerValue2 ? 1 : 0;
    }

    if (typeof value1 === 'number') {
      return (value1 || 0) - (value2 || 0);
    }

    if (value1 instanceof Date) {
      const timestampValue1 = value1 ? value1.getTime() : 0;
      const timestampValue2 = value2 ? value2.getTime() : 0;
      return timestampValue1 - timestampValue2;
    }

    if (value1 === undefined && value2 === undefined) {
      return 0;
    }

    if (value1 === null && value2 === null) {
      return 0;
    }

    console.error(
      `don't know how to sort ${value1} and ${value2} so they have not been sorted.`
    );
    return 0;
  });
  return order === 'ASC' ? sorted : sorted.reverse();
};

export { sortObjects };

const sorter = { sortObjects };
export default sorter;
